/*
 * @Description: 复选框组件初始化配置
 * @Date: 2023-08-20
 */

export default {
  label: '复选框',
  type: 'checkbox',
  property: '',
  value: false,
  child: null,
  options: {
    note: '复选框组件，用于表示开启/关闭某项功能'
  }
} 